import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-14 sm:py-20" data-id="element-128" data-mp="2u5ypq84q8c6b">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-129" data-mp="2z2p6yys9pdtb">
        <h2 className="text-center font-display text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-130" data-mp="2z5bdqw7c3pah">
          Frequently asked questions
        </h2>

        <div className="mt-8 space-y-3" data-id="element-131" data-mp="3rqushnr5b6u7">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/10" data-id="element-132" data-mp="3d15kp9ojs4ky" data-mpi={index}>
                <h3 data-id="element-133" data-mp="9m9ope2p7z8k">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-3 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500" data-id="element-134" data-mp="9lrm7zpg0os7">
                    <span className="text-[15px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-135" data-mp="1vpsq2yccp6om">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={['mt-0.5 h-5 w-5 shrink-0 text-sky-600 transition-transform duration-200 ease-out', isOpen ? 'rotate-180' : ''].join(' ')} aria-hidden="true" data-id="element-136" data-mp="25p1gxibx656r" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-navy-900/5 px-5 py-4 text-[14.5px] leading-relaxed text-navy-800/80" data-id="element-137" data-mp="2ohm6apsets5t">
                    {faq.a}
                  </p> : null}
              </div>;
        })}
        </div>

        <div className="mt-9" data-id="element-138" data-mp="1jqfbegfba9hu">
          <CTAButton label="Yes — I want Mechanics Decision Map™" data-id="element-139" data-mp="1jr72bdxyrj1s" />
        </div>
      </div>
    </section>;
}